import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";
import h3 from '../Images/h3.png'
import h7 from '../Images/h7.png'
import h8 from '../Images/h8.png'
import h2 from '../Images/h2.png'
import { useNavigate } from 'react-router-dom';

// --- Styled Components ---

const SectionWrapper = styled.section`
  padding: 10px 20px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const IntroText = styled.p`
  color: #333;
  line-height: 1.6;
  font-size: 1.1rem;
  margin-bottom: 10px;
  text-align: left;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`;

const Card = styled.div`
  background-color: #0d2a71; // The deep blue from the image
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  margin-bottom: 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CardTitle = styled.h3`
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  padding-bottom: 10px;
`;

const ReadMoreBtn = styled.button`
  background-color: #2b7fff; // The bright blue button
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background-color: #1a66e0;
  }
`;

// --- Mock Data ---

const services = [
  {
    title: "Engineering Services",
    image: h7, 
    link:"/engineeringservices"
  },
  {
    title: "Bathymetric Surveys",
    image: h3,
    link:"/bathymetricservices"
  },
  {
    title: "Offshore Surveys",
    image: h2,
    link:"/offshoresurveys"
  },
  {
    title: "Onshore Surveys",
    image: h8,
    link:'/onshoresurveys'
  }
];

// --- Main Component ---

const ServicesComponent = () => {
  const navigate = useNavigate();
  return (
    <SectionWrapper>
      <Fade triggerOnce direction="up">
        <IntroText>
          <strong style={{color:"#439E6D"}}>PADEC GLOBAL SERVICES LIMITED (PGSL)</strong> is engaged in the provision of Surveying, 
          Civil Engineering Design, Fabrication/Construction, Project Management, Installation and 
          Procurement Services to the onshore, swamp and offshore sectors of the Nigerian oil and gas industry.
        </IntroText>
      </Fade>

      <CardGrid>
        <Fade cascade damping={0.1} triggerOnce direction="up">
          {services.map((service, index) => (
            <Card key={index}>
              <ImageContainer>
                <img src={service.image} alt={service.title} />
              </ImageContainer>
              <CardTitle>{service.title}</CardTitle>
              <ReadMoreBtn onClick={()=>navigate(`${service.link}`)} >Read More</ReadMoreBtn>
            </Card>
          ))}
        </Fade>
      </CardGrid>
    </SectionWrapper>
  );
};

export default ServicesComponent;